import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
// Inter Dependency
import { ButtonsModule } from '../button/button.module';
import { IconModule } from '../icon/icon.module';
import {
  AccordionBodyComponent,
  AccordionComponent,
  AccordionExpandCollapseBodyComponent,
  AccordionExpandCollapseComponent,
  AccordionExpandCollapseRightComponent,
  AccordionGroupComponent,
  AccordionHeadingComponent,
  AccordionHeadingRightComponent
} from './accordion.component';
@NgModule({
  imports: [
    ButtonsModule,
    CommonModule,
    IconModule
  ],
  declarations: [
    AccordionBodyComponent,
    AccordionComponent,
    AccordionExpandCollapseBodyComponent,
    AccordionExpandCollapseComponent,
    AccordionExpandCollapseRightComponent,
    AccordionGroupComponent,
    AccordionHeadingComponent,
    AccordionHeadingRightComponent
  ],
  exports: [
    AccordionBodyComponent,
    AccordionComponent,
    AccordionExpandCollapseBodyComponent,
    AccordionExpandCollapseComponent,
    AccordionExpandCollapseRightComponent,
    AccordionGroupComponent,
    AccordionHeadingComponent,
    AccordionHeadingRightComponent
  ]
})
export class AccordionModule {}
